/* CNOIR Concierge: tell the browser the real displayed width of each product photo so it loads a sharp file (2026-10-18). */
(function () {
  if (!document.querySelector('[data-cnoir-concierge]')) return;
  function fix() {
    document.querySelectorAll('.product__media-list img, .product__media img').forEach(function (img) {
      var w = Math.ceil(img.getBoundingClientRect().width);
      if (w > 0 && img.getAttribute('sizes') !== w + 'px') img.setAttribute('sizes', w + 'px');
    });
  }
  fix();
  window.addEventListener('load', fix);
  var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fix, 200); });
})();
